import { create } from 'zustand';

interface WritingSessionState {
  sessionStartTime: number | null;
  startingWordCount: number;
  currentWordCount: number;
  isActive: boolean;
  start: (wordCount: number) => void;
  updateWordCount: (count: number) => void;
  pause: () => void;
  resume: () => void;
  reset: () => void;
}

export const useWritingSessionStore = create<WritingSessionState>((set) => ({
  sessionStartTime: null,
  startingWordCount: 0,
  currentWordCount: 0,
  isActive: false,

  start: (wordCount) =>
    set({
      sessionStartTime: Date.now(),
      startingWordCount: wordCount,
      currentWordCount: wordCount,
      isActive: true,
    }),

  updateWordCount: (count) => set({ currentWordCount: count }),

  pause: () => set({ isActive: false }),

  resume: () =>
    set((state) => ({
      isActive: true,
      sessionStartTime: state.sessionStartTime ?? Date.now(),
    })),

  reset: () =>
    set({
      sessionStartTime: null,
      startingWordCount: 0,
      currentWordCount: 0,
      isActive: false,
    }),
}));
